export default __webpack_public_path__ + "static/media/animated-package1.3f49f932.png";